/**
 * Score writes on their way to the server right now.
 *
 * A write is only QUEUED when it fails, which can take the full 25s timeout —
 * so for that whole time the queue is empty and a badge reading the queue
 * alone would say "Saved" about a score still in transit. The two scoring
 * hooks mark each request here; `useSyncStatus` reads it beside the queue.
 */
let sending = 0;

const announce = () => window.dispatchEvent(new CustomEvent('syncQueueChanged'));

export const beginSend = () => { sending += 1; announce(); };
export const endSend = () => { sending = Math.max(0, sending - 1); announce(); };
export const sendingCount = () => sending;
